import React, { useRef } from 'react';
import useScreenLoop from '../hooks/useScreenLoop';
import './ScreenplaySnap.css';

// Loose notes on the left of each pair, the same lines in screenplay format
// on the right. Scene headings use a hyphen, as screenplays do.
const LINES = [
  { kind: 'heading', raw: 'ext the gate at twilight', formatted: 'EXT. THE GATE - TWILIGHT' },
  { kind: 'action', raw: 'dante stops under the arch', formatted: 'Dante stops beneath the arch.' },
  { kind: 'character', raw: 'virgil:', formatted: 'VIRGIL' },
  { kind: 'dialogue', raw: 'finish it', formatted: 'Finish it.' },
];

const LOOP = {
  initial: false,
  final: true,
  steps: [
    [true, 3800],
    [false, 1900],
  ],
};

// A few lines of notes that snap into screenplay format and loosen again,
// on a slow loop while they are on screen. Decorative: the copy beside it
// says the same thing in words.
export default function ScreenplaySnap({ className = '' }) {
  const rootRef = useRef(null);
  const formatted = useScreenLoop(rootRef, LOOP);

  return (
    <div
      ref={rootRef}
      className={`screenplay-snap ${formatted ? 'is-formatted' : ''} ${className}`.trim()}
      aria-hidden="true"
    >
      {LINES.map((line) => (
        <span key={line.kind} className={`screenplay-snap-line screenplay-snap-line--${line.kind}`}>
          <span className="screenplay-snap-raw">{line.raw}</span>
          <span className="screenplay-snap-formatted">{line.formatted}</span>
        </span>
      ))}
    </div>
  );
}
